import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Form } from 'react-redux-form'
import classNames from "classnames";
import { path } from 'Constants'
import moment from 'moment'
import { CheckboxE } from 'UI/CustomComponents/Controls';
import Select from 'react-select';

// Actions
import {
    fetchSolutionInScopeValues,
    resetError,
    updateSolutionInScopeValues
} from 'actions/spendActions'

// Utils
import { BreakLine } from 'utils/Utils'

class SolutionInScopeValues extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isLoading: false,
            apiData: [],
            editedScopeRow: [],
            responseMessage: '',
            isError: false,
            regionOption: [],
            selectedRegion: '',
            valueStoryType: [
				{ value: 'Sales', label: 'Sales Values Story'},
		        { value: 'EnablementExecution', label: 'Enablement Value Story'}
			],
            selectedValueStoryType: 'Sales',
        }
        this.loadData = this.loadData.bind(this)
        this.trackScopeVisibilityChanges = this.trackScopeVisibilityChanges.bind(this)
        this.handleSave = this.handleSave.bind(this)
        this.getSaveCode = this.getSaveCode.bind(this)
        this.getDisplayRegion = this.getDisplayRegion.bind(this)
        this.handleRegionAndVsTypeChange = this.handleRegionAndVsTypeChange.bind(this)
    }

    componentDidMount() {
        this.loadData();
    }

    getDisplayRegion = (code) => {
        const normalizedCode = code.toUpperCase();
        if (normalizedCode === 'AMER' || normalizedCode === 'NAMER') {
            return 'North America';
        } else if (normalizedCode === 'EMEA') {
            return 'Europe';
        }
        else if (normalizedCode === 'LAC') {
            return 'Latin America';
        }
        else if (normalizedCode === 'APJ') {
            return 'Asia Pacific Japan';
        }
        return '';
    };

    getSaveCode = (region) => {
        switch (region) {
            case 'North America':
                return 'AMER'; // Save as AMER for consistency
            case 'Europe':
                return 'EMEA';
            case 'Asia Pacific Japan':
                return 'APJ';
            case 'Latin America':
                return 'LAC';
            default:
                return 'AMER';
        }
    };

    loadData() {
        var array1 = [];
        this.props.discovery.regionsList.forEach((element) => {
            var obj = {};
            obj.label = element.Region;
            obj.value = element.Region_Code;
            array1.push(obj);
        });
        this.setState({ regionOption: array1, selectedRegion: this.getSaveCode(this.props.discovery.regionsList[0].Region_Code) }, () => { this.getSolutionInScopeValues(this.getSaveCode(this.props.discovery.regionsList[0].Region_Code),this.state.selectedValueStoryType) });

        // this.getSolutionInScopeValues();
    }

    trackScopeVisibilityChanges(record) {
        var updatedRecords = this.state.editedScopeRow
        if (this.state.editedScopeRow.length === 0)
            updatedRecords.push(record)
        else {
            let index = this.state.editedScopeRow.findIndex(x => x.SOLUTION_IN_SCOPE_ID === record.SOLUTION_IN_SCOPE_ID);
            if (index !== undefined && index !== null && index > -1)
                updatedRecords.splice(index, 1)
            updatedRecords.push(record)
        }
        this.setState({ responseMessage: '', editedScopeRow: updatedRecords, isError: false })
    }

    getSolutionInScopeValues(regionCode,valueStoryType) {
        this.setState({ responseMessage: '', isLoading: true, isError: false });
        this.props.fetchSolutionInScopeValues().then((response) => {
            if (response.status === 200) {
                if (response.data.Result.length === 0) {
                    this.setState({ responseMessage: this.props.content.noRecords, isLoading: false, isError: true });
                }
                else {
                    console.log("api data-----------", response.data.Result)

                    this.setState({ apiData: response.data.Result.filter(option => option.REGION_CD === regionCode && option.VALUE_STORY_TYPE === valueStoryType), isLoading: false, responseMessage: '', isError: false });
                }
            }
            else {
                this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
            }
        }).catch((error) => {
            this.setState({ responseMessage: this.props.content.errorMessage, isLoading: false, isError: true });
        })
    }

    handleSave() {

        this.setState({ isLoading: true, responseMessage: '', isError: false });
        let updatedRecords = this.state.editedScopeRow
        let email = this.props.user.user.Email
        let finalObject = [];
        updatedRecords.map(function (data) {
            let record = {
                'SOLUTION_IN_SCOPE_NAME': data.SOLUTION_IN_SCOPE_NAME,
                'SOLUTION_IN_SCOPE_VALUE': (data.SOLUTION_IN_SCOPE_VALUE === "true" || data.SOLUTION_IN_SCOPE_VALUE === true) ? true : false,
                'UPDATED_BY': email,
                'TRAN_AN_SUPP_AUTO_ELIGIBLE': data.TRAN_AN_SUPP_AUTO_ELIGIBLE == true ? 'Yes' : 'No',
                'UNCLASS_SUPP_AUTO_ELIGIBLE': data.UNCLASS_SUPP_AUTO_ELIGIBLE == true ? 'Yes' : 'No',
                'DIRECT_YES_SUPP_SCC_ELIGIBLE': data.DIRECT_YES_SUPP_SCC_ELIGIBLE == true ? 'Yes' : 'No',
                'FLDG_IN_SCOPE': data.FLDG_IN_SCOPE == true ? 'Yes' : 'No',
                'FG_IN_AUTO_ELG': data.FG_IN_AUTO_ELG == true ? 'Yes' : 'No',
                'TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE': data.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == true ? 'Yes' : 'No',
                'CATALOG_SCOPE': data.CATALOG_SCOPE == true ? 'Yes' : 'No',
                'OUT_SCOPE_SUSPENDED_SUPP': data.OUT_SCOPE_SUSPENDED_SUPP == true ? 'Yes' : 'No',
                'DIRECT_CONNECT_WAVE': data.DIRECT_CONNECT_WAVE || 'No',
                'SOLUTION_IN_SCOPE_ID': data.SOLUTION_IN_SCOPE_ID,
                'MIN_NO_TRANS_BUY_RELN': data.MIN_NO_TRANS_BUY_RELN,
                'MATCH_CONFIDENCE_PARAM': data.MATCH_CONFIDENCE_PARAM,
                'REGION_CD': data.REGION_CD,
                'RISE_SAVING': data.RISE_SAVING == true ? 'Yes' : 'No',
            }
            finalObject.push(record)
        });

        this.props.updateSolutionInScopeValues(finalObject).then((response) => {
            if (response.status === 200) {
                this.setState({
                    apiData: response.data.Result.filter(option => option.REGION_CD === finalObject[0].REGION_CD && option.VALUE_STORY_TYPE === this.state.selectedValueStoryType), editedScopeRow: [],
                    isLoading: false, responseMessage: this.props.content.successMessage,
                    isError: false
                });
            }
            else {
                this.setState({ isLoading: false, responseMessage: this.props.content.errorMessage, isError: true });
            }
        }).catch((error) => {
            this.setState({ isLoading: false, responseMessage: this.props.content.errorMessage, isError: true });
        })
    }

    componentWillUnmount() {
        this.props.resetError()
    }

    handleRegionAndVsTypeChange(RegionCode, VsType) {
        this.setState({ selectedRegion: this.getSaveCode(RegionCode),selectedValueStoryType:VsType }, () => { this.getSolutionInScopeValues(this.getSaveCode(RegionCode),VsType) });
    }

    render() {
        var _instance = this
        var data = _instance.state.apiData !== null && _instance.state.apiData
        var account_yield = data.map(function (data, index) {
            data.TRAN_AN_SUPP_AUTO_ELIGIBLE = (data.TRAN_AN_SUPP_AUTO_ELIGIBLE == null || data.TRAN_AN_SUPP_AUTO_ELIGIBLE == "No" || data.TRAN_AN_SUPP_AUTO_ELIGIBLE == false) ? false : true;
            data.UNCLASS_SUPP_AUTO_ELIGIBLE = (data.UNCLASS_SUPP_AUTO_ELIGIBLE == null || data.UNCLASS_SUPP_AUTO_ELIGIBLE == "No" || data.UNCLASS_SUPP_AUTO_ELIGIBLE == false) ? false : true;
            data.DIRECT_YES_SUPP_SCC_ELIGIBLE = (data.DIRECT_YES_SUPP_SCC_ELIGIBLE == null || data.DIRECT_YES_SUPP_SCC_ELIGIBLE == "No" || data.DIRECT_YES_SUPP_SCC_ELIGIBLE == false) ? false : true;
            data.FLDG_IN_SCOPE = (data.FLDG_IN_SCOPE == null || data.FLDG_IN_SCOPE == "No" || data.FLDG_IN_SCOPE == false) ? false : true;
            data.FG_IN_AUTO_ELG = (data.FG_IN_AUTO_ELG == null || data.FG_IN_AUTO_ELG == "No" || data.FG_IN_AUTO_ELG == false) ? false : true;
            data.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE = (data.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == null || data.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == "No" || data.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE == false) ? false : true;
            data.CATALOG_SCOPE = (data.CATALOG_SCOPE == null || data.CATALOG_SCOPE == "No" || data.CATALOG_SCOPE == false) ? false : true;
            data.OUT_SCOPE_SUSPENDED_SUPP = (data.OUT_SCOPE_SUSPENDED_SUPP == null || data.OUT_SCOPE_SUSPENDED_SUPP == "No" || data.OUT_SCOPE_SUSPENDED_SUPP == false) ? false : true;
            if (data.DIRECT_CONNECT_WAVE == null || data.DIRECT_CONNECT_WAVE === "" || data.DIRECT_CONNECT_WAVE === false) {
                data.DIRECT_CONNECT_WAVE = "No";
            }
            data.SOLUTION_IN_SCOPE_VALUE = (data.SOLUTION_IN_SCOPE_VALUE == null || data.SOLUTION_IN_SCOPE_VALUE == "No" || data.SOLUTION_IN_SCOPE_VALUE == false || data.SOLUTION_IN_SCOPE_VALUE == "false") ? false : true;
            data.MIN_NO_TRANS_BUY_RELN = data.MIN_NO_TRANS_BUY_RELN;
            data.MATCH_CONFIDENCE_PARAM = data.MATCH_CONFIDENCE_PARAM;
            data.REGION_CD = data.REGION_CD;
            data.RISE_SAVING = (data.RISE_SAVING == null || data.RISE_SAVING == "No" || data.RISE_SAVING == false) ? false : true;            

            return (<TableRows
                currentRowData={data}
                index={index}
                readOnly={_instance.props.user.userprofile.Roles[0].indexOf("Admin") > -1 ? false : true}
                trackScopeVisibilityChanges={_instance.trackScopeVisibilityChanges}
                selectedValueStoryType = {_instance.state.selectedValueStoryType}
            />
            );
        });

        // helper to render vertical header cell
        const VerticalHeader = ({ children, thStyle = {} }) => (
            <th style={{ padding: 0, verticalAlign: 'middle', textAlign: 'center', ...thStyle }}>
                <div className="verticalHeader"><span className="verticalHeaderText">{children}</span></div>
            </th>
        );

        const { selectedRegion } = this.state;

        return (
            
            <div className="grid-x" style={{ width: '100%' }}>
                {/* inline style block for vertical headers - tweak sizes here */}
                <style>{`
                    /* container of vertical header */
                    .verticalHeader {
                        height: 140px;            /* total header cell height - tweak to taste */
                        width: 48px;              /* width of header cell (controls column width) */
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        padding: 4px;
                        box-sizing: border-box;
                    }

                    /* vertical text that wraps */
                    .verticalHeaderText {
                        display: inline-block;
                        writing-mode: vertical-rl;   /* layout vertically top-to-bottom, right-to-left */
                        text-orientation: mixed;     /* allow glyphs to remain upright when possible */
                        white-space: normal;         /* allow wrapping */
                        overflow-wrap: break-word;
                        word-break: break-word;
                        max-height: 128px;           /* prevent overflow beyond container */
                        line-height: 1.1;
                        font-weight: 600;
                        font-size: 13px;
                        text-align: center;
                        transform: none;             /* no rotation needed with writing-mode */
                        padding: 0 2px;
                    }

                    /* fallback for very old browsers: still allow rotated headers (if writing-mode unsupported) */
                    @supports not (writing-mode: vertical-rl) {
                      .verticalHeaderText {
                        transform: rotate(-90deg);
                        display: inline-block;
                        max-width: 120px;
                        white-space: normal;
                        word-break: break-word;
                      }
                    }

                    /* table styling */
                    table.basic-table { border-collapse: collapse; width: 100%; }
                    table.basic-table thead th { border-left: 1px solid #ddd; border-bottom: 1px solid #ddd; padding: 4px; }
                    table.basic-table tbody td { padding: 6px 8px; border-left: 1px solid #eee; border-bottom: 1px solid #eee; vertical-align: middle; }
                `}</style>

                <div className="medium-12">
                    {(this.state.isLoading) ?
                        <img style={{ display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
                            src={path + `images/ajax-loader.gif`} alt="" /> : null}
                </div>
                <div className="medium-12">
                    <div className="grid-x">
                        <div className="medium-5 float-left" style={{ fontSize: '1.2rem', paddingBottom: '8px' }}>{BreakLine(this.props.content.scopeValueHeader)}</div>
                        <div className="medium-7 float-left" style={{ display: 'flex' }} >
                            {this.state.isError ?
                                <div style={{ margin: '0 0 0.5rem', color: 'red' }}>{this.state.responseMessage}</div> :
                                <div style={{ margin: '0 0 0.5rem', color: '#4fb81c' }}>{this.state.responseMessage}</div>
                            }
                        </div>
                        <div className="medium-3"></div>
                    </div>
                    <div className="grid-x">
                        <div className="medium-11 float-left pb10">
                            {/* {this.props.content.accountYieldDesc} */}
                        </div>
                        {this.props.user.userprofile.Roles[0].indexOf("Admin") > -1 ?
                            <div className="medium-1 pb5">
                                <button className={classNames('float-right',
                                    {
                                        'hand-cursor': this.state.isLoading ? false : (this.state.editedScopeRow.length > 0),
                                        'gray-scale': this.state.isLoading ? true : (this.state.editedScopeRow.length === 0)
                                    })}
                                    onClick={this.handleSave}
                                    disabled={this.state.isLoading ? true : this.state.editedScopeRow.length === 0} type="submit" float >
                                    <img width="25" title={this.props.content.save} src="images/save_active.svg" />
                                </button>
                            </div> : null}
                    </div>
                </div>
                {this.state.apiData.length > 0 ?
                    <div className="medium-12">
                        <Form model="netwrokEnablementMatchTypeParameter">
                            <div className="basic-table">
                                <table style={{ border: 'solid', borderWidth: '1px' }}>
                                    <tbody>
                                        <tr>
                                        <td style={{ width: '30%' }}><div>Value Story Type: </div>
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                <div>                                                     
                                                    <Select
                                                    className="border-less-DD"
                                                    model="discovery.Region"
                                                    id="discovery.Region"
                                                    placeholder='Value Story Type'
                                                    value={this.state.valueStoryType.filter(option => option.value ===this.state.selectedValueStoryType)}
                                                    noOptionsMessage={() => null}
                                                    onChange={(value) => this.handleRegionAndVsTypeChange(selectedRegion, value.value)}
                                                    options={this.state.valueStoryType}
                                                // isSearchable={false}
                                                />
                                                </div>
                                            </td>
                                            <td style={{ width: '30%' }}><div>Regional Model: </div>
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                <div>   <Select
                                                    className="border-less-DD"
                                                    model="discovery.Region"
                                                    id="discovery.Region"
                                                    placeholder={this.props.discovery.regionsLabel}
                                                    value={this.state.regionOption.filter(option => option.value === this.getDisplayRegion(this.state.selectedRegion))}
                                                    noOptionsMessage={() => null}
                                                    onChange={(value) => this.handleRegionAndVsTypeChange(value.value,this.state.selectedValueStoryType)}
                                                    options={this.state.regionOption}
                                                // isSearchable={false}
                                                />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="basic-table">
                                    <thead>
                                        <tr className="eachRow">
                                            <th style={{ padding: '8px 6px', width: '220px', textAlign: 'left' }}>{this.props.content.solutionInScopeValue}</th>
                                            <VerticalHeader thStyle={{ width: 100 }}>{this.props.content.visibilityFlag}</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 200 }}>Include Direct Connect Wave using</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 120 }}>Minimum # of transacting buyer relationships</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 210 }}>Match Confidence</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Enable Only Transacting SAP Business Network Suppliers</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Are Catalogs In Scope</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Transacting SAP Business Network Supplier Automation Eligible</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Unclassified suppliers automation eligible</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Enforced Suppliers are Out of Scope</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>When Direct = Yes, supplier is SCC eligible</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Fieldglass in scope?</VerticalHeader>
                                            <VerticalHeader thStyle={{ width: 60 }}>Fieldglass matched suppliers automatically Fieldglass eligible</VerticalHeader>                                            
                                            <VerticalHeader thStyle={{ width: 60 }}>Savings</VerticalHeader>
                                            <th style={{ padding: '8px 6px' }}>{this.props.content.updatedBy}</th>
                                            {/* <th style={{padding : '8px 6px'}}>{this.props.content.updatedOn}</th> */}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {account_yield}
                                    </tbody>
                                </table>
                            </div>
                        </Form>
                    </div>
                    : null
                }
            </div>
        )
    }
}

class TableRows extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            transactionEligible: false,
            unclassifiedEligible: false,
            sCCEligible: false,
            fieldglass: false,
            fieldglassEligible: false,
            riseSaving:false,
            matchConfidenceOption: [{ label: 'High', value: 'High' }, { label: 'Medium & High', value: 'Medium,High' },{ label: 'Low, Medium & High', value: 'Low,Medium,High' }],
            matchConfidenceOptionEnablementVS: [{ label: 'High', value: 'High' }, { label: 'Medium & High', value: 'Medium,High' }],
            includeSupplierDirectConnectOptions: [{ label: '1', value: 1 }, { label: '2', value: 2 }, { label: '3', value: 3 }],
            includeSupplierDirectConnectOptionsSalesVS: [{ label: '3', value: 3 }],
        };
    }

    onChangeEvent(val) {
        var editingRow = this.props.currentRowData;
        let editedValue = val.target.value.trim()
        if (editedValue.toString() !== editingRow[val.target.id].toString()) {
            editingRow[val.target.id] = editedValue
            this.props.trackScopeVisibilityChanges(editingRow)
        }
    }
    selectIstransactionEligibleChk(e) {
        //this.setState({ transactionEligible: !this.state.transactionEligible }, () => {
        var editingRow = this.props.currentRowData;
        editingRow['TRAN_AN_SUPP_AUTO_ELIGIBLE'] = !editingRow['TRAN_AN_SUPP_AUTO_ELIGIBLE'] //= true ? 'Yes' : 'No';
        this.props.trackScopeVisibilityChanges(editingRow);
        //});
    }
    selectIsSupplierEligibleChk(e) {
        //this.setState({ transactionEligible: !this.state.transactionEligible }, () => {
        var editingRow = this.props.currentRowData;
        editingRow['TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE'] = !editingRow['TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE'] //= true ? 'Yes' : 'No';
        this.props.trackScopeVisibilityChanges(editingRow);
        //});
    }
    selectIsCatalogInScopeChk(e) {
        //this.setState({ transactionEligible: !this.state.transactionEligible }, () => {
        var editingRow = this.props.currentRowData;
        editingRow['CATALOG_SCOPE'] = !editingRow['CATALOG_SCOPE'] //= true ? 'Yes' : 'No';
        this.props.trackScopeVisibilityChanges(editingRow);
        //});
    }

    selectIsDirectConnectDropdown(e) {
        var editingRow = this.props.currentRowData;
        editingRow['DIRECT_CONNECT_WAVE'] = e.target.value;
        this.props.trackScopeVisibilityChanges(editingRow);
      }
      

    selectIsOutOfScopeSuppChk(e) {
        //this.setState({ transactionEligible: !this.state.transactionEligible }, () => {
        var editingRow = this.props.currentRowData;
        editingRow['OUT_SCOPE_SUSPENDED_SUPP'] = !editingRow['OUT_SCOPE_SUSPENDED_SUPP'] //= true ? 'Yes' : 'No';
        this.props.trackScopeVisibilityChanges(editingRow);
        //});
    }



    selectIsunclassifiedEligibleChk(e) {
        this.setState({ unclassifiedEligible: !this.state.unclassifiedEligible }, () => {
            var editingRow = this.props.currentRowData;
            editingRow['UNCLASS_SUPP_AUTO_ELIGIBLE'] = !editingRow['UNCLASS_SUPP_AUTO_ELIGIBLE'] //= true ? 'Yes' : 'No';
            this.props.trackScopeVisibilityChanges(editingRow);
            //this.props.userData.UnclassifiedEligible = this.state.unclassifiedEligible;
        });
    }

    selectIssCCEligibleChk(e) {
        this.setState({ sCCEligible: !this.state.sCCEligible }, () => {
            var editingRow = this.props.currentRowData;
            editingRow['DIRECT_YES_SUPP_SCC_ELIGIBLE'] = !editingRow['DIRECT_YES_SUPP_SCC_ELIGIBLE'] //= true ? 'Yes' : 'No';
            this.props.trackScopeVisibilityChanges(editingRow);
            //this.props.userData.SCCEligible = this.state.sCCEligible;
        });
    }

    selectIsfieldglassChk(e) {
        this.setState({ fieldglass: !this.state.fieldglass }, () => {
            var editingRow = this.props.currentRowData;
            editingRow['FLDG_IN_SCOPE'] = !editingRow['FLDG_IN_SCOPE'] //= true ? 'Yes' : 'No';
            this.props.trackScopeVisibilityChanges(editingRow);
            //this.props.userData.Fieldglass = this.state.fieldglass;
        });
    }

    selectIsRiseSavingChk(e) {
        this.setState({ riseSaving: !this.state.riseSaving }, () => {
            var editingRow = this.props.currentRowData;
            editingRow['RISE_SAVING'] = !editingRow['RISE_SAVING'] //= true ? 'Yes' : 'No';
            this.props.trackScopeVisibilityChanges(editingRow);
            //this.props.userData.Fieldglass = this.state.fieldglass;
        });
    }

    selectIsfieldglassEligibleChk(e) {
        this.setState({ fieldglassEligible: !this.state.fieldglassEligible }, () => {
            var editingRow = this.props.currentRowData;
            editingRow['FG_IN_AUTO_ELG'] = !editingRow['FG_IN_AUTO_ELG'] //= true ? 'Yes' : 'No';
            this.props.trackScopeVisibilityChanges(editingRow);
            //this.props.userData.FieldglassEligible  = this.state.fieldglassEligible ;
        });
    }

    handleMatchConfidenceChange(value) {
        var editingRow = this.props.currentRowData;
        editingRow['MATCH_CONFIDENCE_PARAM'] = value
        this.props.trackScopeVisibilityChanges(editingRow);
    }

    handleincludeSuppDirectConnectChange(value) {
        var editingRow = this.props.currentRowData;
        editingRow['MIN_NO_TRANS_BUY_RELN'] = value
        this.props.trackScopeVisibilityChanges(editingRow);
    }

    render() {
        var bindValues = this.props.currentRowData;
        return (
            <tr className="eachRow">
                <td model="standardAccountYield.SOLUTION_IN_SCOPE_NAME">{bindValues.SOLUTION_IN_SCOPE_NAME}</td>

                <td>
                    <select style={{ height: '30px', width: '70px' }}
                        id={'SOLUTION_IN_SCOPE_VALUE'}
                        onChange={this.onChangeEvent.bind(this)}
                        value={bindValues.SOLUTION_IN_SCOPE_VALUE}
                        readOnly={this.props.readOnly}
                        disabled={this.props.readOnly}
                    >
                        <option value="true">Yes</option>
                        <option value="false">No</option>
                    </select>
                </td>
                <td model="standardAccountYield.directConnectWave">
                    <select
                        value={this.props.currentRowData.DIRECT_CONNECT_WAVE || 'No'}
                        onChange={(e) => this.selectIsDirectConnectDropdown(e)}
                    >
                        <option value="Enablement_Wave">Enablement Wave</option>
                        <option value="Onboarding_Workstream">Onboarding Workstream</option>
                        <option value="No">No</option>
                    </select>
                </td>
                <td model="standardAccountYield.fieldglassEligible"> <Select
                    className="border-with-DD dropDownContent"
                    id='aribaNetworkMatched'
                    autocomplete='true'
                    value={this.state.includeSupplierDirectConnectOptions.filter(
                        option => option.value === bindValues.MIN_NO_TRANS_BUY_RELN
                    )}
                    onChange={value => this.handleincludeSuppDirectConnectChange(value.value)}
                    options={this.props.selectedValueStoryType == 'Sales' ? this.state.includeSupplierDirectConnectOptionsSalesVS : this.state.includeSupplierDirectConnectOptions}
                    isSearchable={false}
                    noOptionsMessage={() => null} />        </td>
                <td model="standardAccountYield.fieldglassEligible"> <Select
                    className="border-with-DD dropDownContent"
                    id='aribaNetworkMatched'
                    autocomplete='true'
                    value={this.state.matchConfidenceOption.filter(
                        option => option.value === bindValues.MATCH_CONFIDENCE_PARAM
                    )}
                    onChange={value => this.handleMatchConfidenceChange(value.value)}
                    options={this.props.selectedValueStoryType == 'Sales' ? this.state.matchConfidenceOption : this.state.matchConfidenceOptionEnablementVS}
                    isSearchable={false}
                    noOptionsMessage={() => null} />        </td>
                <td model="standardAccountYield.supplierEligible"> <CheckboxE disabled={false} checked={bindValues.TRANS_SAP_BUSS_NET_SUPP_ELIGIBLE} onClick={(e) => this.selectIsSupplierEligibleChk(e)} /> </td>
                <td model="standardAccountYield.catalogInScope"> <CheckboxE disabled={false} checked={bindValues.CATALOG_SCOPE} onClick={(e) => this.selectIsCatalogInScopeChk(e)} /> </td>
                <td model="standardAccountYield.transactionEligible"> <CheckboxE disabled={false} checked={bindValues.TRAN_AN_SUPP_AUTO_ELIGIBLE} onClick={(e) => this.selectIstransactionEligibleChk(e)} /> </td>
                <td model="standardAccountYield.unclassifiedEligible"> <CheckboxE disabled={false} checked={bindValues.UNCLASS_SUPP_AUTO_ELIGIBLE} onClick={(e) => this.selectIsunclassifiedEligibleChk(e)} /> </td>
                <td model="standardAccountYield.outScopeSuspendedSupplier"> <CheckboxE disabled={false} checked={bindValues.OUT_SCOPE_SUSPENDED_SUPP} onClick={(e) => this.selectIsOutOfScopeSuppChk(e)} /> </td>
                <td model="standardAccountYield.sCCEligible"> <CheckboxE disabled={false} checked={bindValues.DIRECT_YES_SUPP_SCC_ELIGIBLE} onClick={(e) => this.selectIssCCEligibleChk(e)} /> </td>
                <td model="standardAccountYield.fieldglass"> <CheckboxE disabled={false} checked={bindValues.FLDG_IN_SCOPE} onClick={(e) => this.selectIsfieldglassChk(e)} /> </td>
                <td model="standardAccountYield.fieldglassEligible"> <CheckboxE disabled={false} checked={bindValues.FG_IN_AUTO_ELG} onClick={(e) => this.selectIsfieldglassEligibleChk(e)} /> </td>
                
                <td model="standardAccountYield.riseSaving"> <CheckboxE disabled={false} checked={bindValues.RISE_SAVING} onClick={(e) => this.selectIsRiseSavingChk(e)} /> </td>
                <td model="standardAccountYield.UpdatedBy">{bindValues.UPDATED_BY}</td>
                {/* <td model="standardAccountYield.UpdatedOn">{moment(bindValues.UPDATED_DATE).format('L')}</td> */}
            </tr>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        language: state.language,
        ui: state.content.ui,
        user: state.default,
        spendDetails: state.spendDetails,
        content: state.content.menu.EnablementParametersManager[0].SELogicAndAnalysisTab,
        discovery: state.content.discovery.form,
    }
}


const mapDispatchToProps = (dispatch) => {
    return {
        resetError: () => dispatch(resetError()),
        fetchSolutionInScopeValues: () => dispatch(fetchSolutionInScopeValues()),
        updateSolutionInScopeValues: (data) => dispatch(updateSolutionInScopeValues(data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SolutionInScopeValues)
